import { area, polygon } from '@turf/turf';

/**
 * Calculates the area of a polygon in square meters.
 * @param coordinates Array of [longitude, latitude] pairs
 * @param conversionType Conversion type. Default is square kilometers
 */
export function calculateArea(
    coordinates: number[][],
    conversionType: 'sq-m' | 'sq-km' = 'sq-km',
): number {
    // 1. Ensure the polygon is 'closed' (last point == first point)
    const firstPoint = coordinates[0];
    const lastPoint = coordinates[coordinates.length - 1];

    if (firstPoint[0] !== lastPoint[0] || firstPoint[1] !== lastPoint[1]) {
        coordinates.push(firstPoint);
    }

    // 2. Create the Turf polygon object
    // Note: Turf expects an array of rings (the first is the outer boundary)
    const poly = polygon([coordinates]);

    // 3. Calculate area (returns square meters by default)
    const areaInSqMeters = area(poly);

    if (conversionType === 'sq-km') {
        return areaInSqMeters / 1_000_000;
    }

    return areaInSqMeters;
}
